import addMoneyMask from "./addMoneyMask";
import useConsorcioStore from "../storeModules/useConsorcioStore";
import useInitialConfigStore from "../storeModules/useInitialConfigStore";
import useInsuranceStore from "../storeModules/useInsuranceStore";
import usePaymentStore from "../storeModules/usePaymentStore";
import {
  getFilteredPlansByTipoTabela,
  STEPS_WITHOUT_BUTTON_OPTIONS,
} from "./buildStepStructuredItems";

const resolveButtonText = (button) => {
  if (!button?.props?.text) return null;
  const { text } = button.props;
  return typeof text === "function" ? text() : text;
};

export const buildPlanCarouselOptions = (fetchedPlans = []) => {
  const { tipoTabela } = useInitialConfigStore.getState();
  const options = [];

  fetchedPlans.forEach((plan) => {
    if (plan.planoCardType === "simular-novamente") {
      options.push("SIMULAR NOVAMENTE");
      return;
    }

    getFilteredPlansByTipoTabela(plan, tipoTabela).forEach((tipo) => {
      options.push(
        `${addMoneyMask(plan.bemValor ?? plan.bemCredito)} em ${plan.planoMeses} parcelas de ${addMoneyMask(tipo.valorParcela)}`
      );
    });
  });

  return options;
};

export const buildCategoryCarouselOptions = () =>
  (useConsorcioStore.getState().filteredCategories ?? [])
    .map((category) => category.text)
    .filter(Boolean);

export const buildInsuranceSelectOptions = () => ["CONFIRMAR"];

const getStepBotOptions = (step) => {
  if (!step) return [];

  if (step.useCarouselPlan || step.useCarousel) {
    return [];
  }

  if (step.name === "escolha_seguro") {
    return buildInsuranceSelectOptions();
  }

  if (STEPS_WITHOUT_BUTTON_OPTIONS.has(step.name)) {
    return [];
  }

  const rawOptions = typeof step.options === "function" ? step.options() : step.options;
  const optionTexts = (rawOptions ?? []).map((option) => option.text).filter(Boolean);
  if (optionTexts.length) return optionTexts;

  const stepButtonTexts = (step.stepButtons ?? [])
    .map(resolveButtonText)
    .filter(Boolean);
  if (stepButtonTexts.length) return stepButtonTexts;

  return (step.buttons ?? []).map(resolveButtonText).filter(Boolean);
};

export default getStepBotOptions;
